export const NOTARY_VIEW_DETAILS = 'VIEW';
export const NOTARY_EDIT_DETAILS = 'EDIT';
export const NOTARY_ADD_APPLICATION = 'ADD';
export const NOTARY_VIEW_APPLICATION = 'VIEW';
export const USER_UPDATE_DETAILS = 'UPDATE';
export const NOTARY_TABLE = 'TABLE';
export const NOTARY_SUBMIT_APPLICATION = 'SUBMIT';
export const NOTARY_APPLICATION_STATUS_NEW = 'NEW';
export const NOTARY_APPLICATION_STATUS_UPDATED = 'UPDATED';
export const NOTARY_APPLICATION_STATUS_APPROVED = 'APPROVED';
export const NOTARY_APPLICATION_STATUS_UPDATE_PERSON = 'UPDATE_PERSON';
export const NOTARY_FUNCTION_STATUS_ACTIVE = 'ACTIVE';
export const NOTARY_FUNCTION_STATUS_INACTIVE = 'INACTIVE';
export const NOTARY_FUNCTION_STATUS_NEW = 'NEW';
export const REGULAR_EXPRESSION_UID =
  /^((CHE|ADM)-((\d{3})(\.{1})){2}(\d{3})|)$/;
export const REGULAR_EXPRESSION_EMAIL =
  /^(([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+)|)$/;
export const REGULAR_EXPRESSION_POST_CODE = /^([1-9][0-9]{3}|)$/;
// eslint-disable-next-line max-len
export const REGULAR_EXPRESSION_MOBILE_NUMBER =
  /^(((\+41|0041|0)\s?7(\s?[5-9])(\s?[0-9]){7})|(\+?(\s?[0-9]){10,15}))$/;
export const CONTRACT_REGISTRATION = 'REGISTRATION';
export const CONTRACT_TERMINATION = 'TERMINATION';
export const SIGNATURE_DECLARATION = 'SIGNATURE_DECLARATION';
export const UPLOAD_ACTION_TYPE = {
  NEW_DOCUMENT: 'newDocument',
  NEW_VERSION: 'newVersion'
};
export const NAV_COLOR_SELECTED = '#2e383f';
export const NAV_COLOR_UNSELECTED = 'white';
export const NAV_SELECT_LOGIN = 'login';
export const NAV_SELECT_REGISTER = '/';
export const NAV_SELECT_NEWS = '/news/';
export const NAV_SELECT_HOME = '/home/';
export const NAV_SELECT_EMPLOYEE = '/employee-management/';
export const NAV_SELECT_ARCHIVE = '/archive/';
export const NAV_SELECT_APPLICATIONS = '/applications/';
export const NAV_SELECT_PROFILE = '/profile/';
export const NAV_SELECT_SIGNER = '/signer/';

export const URL_MANUAL_DE = '/Bestellungsanleitung.pdf';
export const URL_MANUAL_FR = '/Instructions_de_commande.pdf';

export const CONSENT_CODE_CHARS = '0123456789';

export const USER_TYPE_EMPLOYEE = 'EMPLOYEE';
export const USER_TYPE_NOTARY = 'NOTARY';
export const USER_TYPE_STATE_NOTARY = 'STATE_NOTARY';
export const USER_TYPE_ADMIN = 'ADMINISTRATIVE';

export const ERROR_CONTENT_TOO_LARGE = 'ERROR_CONTENT_TOO_LARGE';
